module.exports = __webpack_public_path__ + "static/img/3.72819c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/3.png
// module id = JTgv
// module chunks = 0